export const totalContribution = [
    {
        "fund_type": "Regular Resources",
        "color": "16537d"
    }
    , {
        "fund_type": "Other Resources",
        "color": "52abe9"
    }
]
export const budgetSource = [
    {
        "fund_type": "Regular Resources",
        "color": "16537d"
    }
]


// WEBPACK FOOTER //
// ./static/assets/json/legendData.js